import { sagas as vehiclesSagas } from './modules/vehicles'

export default [...vehiclesSagas]
